import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const DigitalRetailOfferTypeAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "digital-retail-offer-type" */ './digital-retail-offer-type'),
  componentName: 'DigitalRetailOfferType',
});
